module.exports = __webpack_public_path__ + "img/PHONE.a6c5cd2f.svg";